import { createContext, ReactNode, useCallback, useContext, useState } from 'react'

import { LoginApiResponse } from '../types/user/types'

type AuthContextType = {
  isAuthenticated: boolean
  token: string | null
  oidCliente: number | null
  login: (auth: LoginApiResponse) => void
  logout: () => void
}

const AuthContext = createContext<AuthContextType | undefined>(undefined)

export const AuthProvider = ({ children }: { children: ReactNode }) => {
  const [token, setToken] = useState<string | null>(() => {
    return localStorage.getItem('token')
  })

  const [oidCliente, setOidCliente] = useState<number | null>(() => {
    return Number(localStorage.getItem('oidCliente'))
  })

  const login = useCallback((auth: LoginApiResponse) => {
    localStorage.setItem('token', auth.token)
    localStorage.setItem('oidCliente', auth.oidCliente.toString())
    setToken(auth.token)
    setOidCliente(auth.oidCliente)
  }, [])

  const logout = useCallback(() => {
    localStorage.removeItem('token')
    localStorage.removeItem('oidCliente')
    setToken(null)
    setOidCliente(null)
  }, [])

  const isAuthenticated = Boolean(token)

  return (
    <AuthContext.Provider value={{ isAuthenticated, token, oidCliente, login, logout }}>
      {children}
    </AuthContext.Provider>
  )
}

export const useAuth = () => {
  const ctx = useContext(AuthContext)
  if (!ctx) throw new Error('useAuth deve ser usado dentro de <AuthProvider>')
  return ctx
}
